var _rect, _circle, _circle2, _path, _circle3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChip10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 76,
    height: 76,
    rx: 38,
    fill: "url(#paint0_linear)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 38,
    r: 34.5,
    stroke: "white",
    strokeWidth: 7,
    strokeMiterlimit: 2.16568,
    strokeDasharray: "16 11"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 37.5,
    r: 25.5,
    fill: "black",
    fillOpacity: 0.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.4355 44H31.7197V36.5645L31.7461 35.3428L31.79 34.0068C31.3389 34.458 31.0254 34.7539 30.8496 34.8945L29.373 36.0811L28.0635 34.4463L32.2031 31.1504H34.4355V44ZM46.916 37.5752C46.916 39.8193 46.5469 41.4805 45.8086 42.5586C45.0762 43.6367 43.9453 44.1758 42.416 44.1758C40.9336 44.1758 39.8145 43.6191 39.0586 42.5059C38.3086 41.3926 37.9336 39.749 37.9336 37.5752C37.9336 35.3076 38.2998 33.6377 39.0322 32.5654C39.7646 31.4873 40.8926 30.9482 42.416 30.9482C43.8984 30.9482 45.0176 31.5107 45.7734 32.6357C46.5352 33.7607 46.916 35.4072 46.916 37.5752ZM40.6318 37.5752C40.6318 39.1514 40.7666 40.2822 41.0361 40.9678C41.3115 41.6475 41.7715 41.9873 42.416 41.9873C43.0488 41.9873 43.5059 41.6416 43.7871 40.9502C44.0684 40.2588 44.209 39.1338 44.209 37.5752C44.209 35.999 44.0654 34.8682 43.7783 34.1826C43.4971 33.4912 43.043 33.1455 42.416 33.1455C41.7773 33.1455 41.3203 33.4912 41.0449 34.1826C40.7695 34.8682 40.6318 35.999 40.6318 37.5752Z",
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 37.5,
    r: 20,
    stroke: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 38,
    y1: 0,
    x2: 38,
    y2: 76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.645138,
    stopColor: "#1235B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C2FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChip10);
export default __webpack_public_path__ + "static/media/chip10.37f8d8c63238320157dbc1c69cae97fb.svg";
export { ForwardRef as ReactComponent };